import * as zod from 'zod';

import { ModbusTCPServerCommand } from '@sb/integrations/implementations/ModbusTCPServer/command';

export const NetworkRequestArguments = zod.object({
  command: ModbusTCPServerCommand,
});

export type NetworkRequestArguments = zod.infer<typeof NetworkRequestArguments>;
